import { render, staticRenderFns } from "./StepsOptionsBeard.vue?vue&type=template&id=24c80592"
import script from "./StepsOptionsBeard.vue?vue&type=script&lang=js"
export * from "./StepsOptionsBeard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports